export const MapBoxAPIToken: string = 'pk.eyJ1IjoiYXRyaXRlY3Jhc211cyIsImEiOiJja25veW1nOWMxazE1Mm9ueHhlb2hyY2xzIn0.vVkapGT_NIPM0oWx5-AtQQ';